var map = {
	"./g-account-edit.vue": 89404,
	"./g-account-register.vue": 42872,
	"./g-account-username_change.vue": 23325,
	"./g-account-userpassword_change.vue": 42830,
	"./g-login-activate-mail.vue": 6462,
	"./g-login-activate.vue": 994,
	"./g-login-error.vue": 20366,
	"./g-login-join.vue": 69848,
	"./g-login-login.vue": 51207,
	"./g-login-recovery.vue": 94633,
	"./g-login-register-done.vue": 32576,
	"./g-login-register.vue": 4331,
	"./g-login-reset.vue": 46947
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48645;